'use client'

import Script from 'next/script'
import * as React from 'react'

import { useIsLoggedInQuery, useUserIdQuery } from 'auth/hooks'
import {
  initScript as googleSiteTagInitScript,
  scriptUrl as googleSiteTagScriptUrl,
  globalSiteInit,
} from '@repo/analytics/google-site-tag'

export const GlobalSiteTag = ({ disableAds = false }: { disableAds?: boolean }) => {
  const isLoggedInQuery = useIsLoggedInQuery()
  const userIdQuery = useUserIdQuery()

  React.useEffect(() => {
    if (isLoggedInQuery.isFetched) {
      // oxlint-disable-next-line unicorn/no-lonely-if
      if (typeof window.gtag === 'function') {
        globalSiteInit(isLoggedInQuery.data ? userIdQuery.data || null : null)
      }
    }
  }, [isLoggedInQuery.isFetched, isLoggedInQuery.data, userIdQuery.data])

  return (
    <>
      <Script id="global-site-tag-script-init" strategy="afterInteractive">
        {googleSiteTagInitScript({ disableAds })}
      </Script>
      <Script
        id="global-site-tag-script"
        src={googleSiteTagScriptUrl}
        strategy="afterInteractive"
      />
    </>
  )
}
